import { render, staticRenderFns } from "./NewMyinfo.vue?vue&type=template&id=8afbdaca&scoped=true&class=white&"
import script from "./NewMyinfo.vue?vue&type=script&lang=ts&"
export * from "./NewMyinfo.vue?vue&type=script&lang=ts&"
import style0 from "./NewMyinfo.vue?vue&type=style&index=0&id=8afbdaca&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8afbdaca",
  null
  
)

export default component.exports